<div class="reference_body">
  <main class="reference_main">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">

      <div class="container-fluid">

    <div class="reference_view_table">
      <div class="gmou">
        <div class="the_header_view">
          <div class="row">
            <div class="col-md-6">
              <h3 class="header" style="margin-top: 2rem;">Projects</h3>
            </div>
            <div class="col-md-6">
              <div class="filter_button pull-right">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                  <mat-button-toggle value="grid" routerLink="/project/gmou"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
                  <mat-button-toggle mat-raised-button value="grid" color="primary" (click)="filterProjectModal()"><mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</mat-button-toggle>
                </mat-button-toggle-group>
                <!-- <button mat-raised-button color="primary" (click)="filterProjectModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->
               </div>
            </div>
          </div>
        </div>



        <div class="monitor_project_drop">


          <div class="other_details" *ngIf="status" [@fadeInAnimation]>

            <div class="the_card" id="print-section">
              <div class="row top_information">
                <div class="company col-md-8">
                  <h4 class="the__name_project">
                    <!-- <img src="assets/images/components/icons8-microsoft-excel-50.png" height="40px" alt="" class="company_logo"> -->
                    List of Projects
                  </h4>
                </div>
                <div class="real_time col-md-4 mb-3">
                  <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">
                    <mat-button-toggle value="list" color="accent" (click)="onList()"><mat-icon class="example-tab-icon">list</mat-icon></mat-button-toggle>
                    <mat-button-toggle value="grid" (click)="onGrid()"><mat-icon class="example-tab-icon">view_module</mat-icon></mat-button-toggle>
                    <mat-button-toggle mat-raised-button value="grid" (click)="onCreateProject()"><mat-icon class="example-tab-icon">add</mat-icon> Add New Project</mat-button-toggle>
                  </mat-button-toggle-group>
                  <!-- <button mat-raised-button>Add New Project</button> -->

                </div>
              </div>

              <!-- <h4 class="the___top-heading" *ngIf="GMOUName">project detail report for {{GMOUName}}</h4> -->
              <div class="list" *ngIf="listView" [@fadeInAnimation]>
                <div class="the__project-report-table" *ngIf="selectedProjects.length > 0">
                  <input type="text" [(ngModel)]="term" matInput placeholder="Search with any field name" id="id_number">
                  <div class="the___head">
                    <span class="item">Project Category</span>
                    <span class="item">Project Type</span>
                    <span class="item">Project Name</span>
                    <span class="item">Budget</span>
                    <!-- <span class="item">Vendor</span> -->
                    <span class="item">State</span>
                    <span class="item">LGA</span>
                    <span class="item" *ngIf="genericBlockLabel">{{genericBlockLabel}}</span>
                    <span class="item" *ngIf="genericFieldLabel">{{genericFieldLabel}}</span>
                    <span class="item">Actions</span>
                  </div>
                  <div class="the___head" *ngFor="let project of selectedProjects | filter:term; index as i" (click)="onViewProject(project)"  style="cursor: pointer;">
                    <span class="item">{{project.GMOUCategory}}</span>
                    <span class="item">{{project.GMOUType}}</span>
                    <span class="item">{{project.ProjectTitle}}</span>
                    <span class="item" *ngIf="project.Currency">{{project.Budget | currency:project.Currency:'symbol-narrow'}}</span>

                    <span class="item">
                      <span  *ngFor="let data of project?.States">
                        {{data?.StateName}}
                      </span>
                    </span>
                    <span class="item">
                      <span  *ngFor="let data of project?.Lgas">
                        {{data?.LgaName}}
                      </span>
                    </span>
                   <span class="item">
                    <span  *ngFor="let oilField of project?.OilFields">
                      {{oilField?.OilFieldName}}
                     </span>
                   </span>
                  <span class="item">
                    <span  *ngFor="let oilBlock of project?.OilBlocks">
                      {{oilBlock?.OilBlockName}}
                    </span>
                  </span>
                    <span class="item">
                      <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopImmediatePropagation()" class="ml-auto" aria-label="Example icon-button with a menu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="onEdit(project)">
                          <mat-icon>edit</mat-icon>
                          <span>Edit</span>
                        </button>


                        <button mat-menu-item (click)="onDelete(project.id)">
                          <mat-icon>delete</mat-icon>
                          <span>Delete</span>
                        </button>
                      </mat-menu>
                    </span>
                  </div>



                </div>
              </div>


              <div class="grid" *ngIf="gridView" [@fadeInAnimation]>
              <div class="row">
                <div *ngFor="let project of selectedProjects; index as i" (click)="onViewProject(project)"   style="cursor: pointer;">
                 <div class="col-md-4">
                  <div class="card">
                    <div class="card-header">
                    <div class="row">
                      <div class="col-md-9">
                     <p style="margin-top: 10px; font-weight: bold;">Budget: {{project.Budget | currency:project.Currency:'symbol-narrow'}}</p>
                      </div>
                    <div class="col-md-3">

                      <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopImmediatePropagation()" class="ml-auto" aria-label="Example icon-button with a menu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="onEdit(project)">
                          <mat-icon>edit</mat-icon>
                          <span>Edit</span>
                        </button>


                        <button mat-menu-item (click)="onDelete(project.id)">
                          <mat-icon>delete</mat-icon>
                          <span>Delete</span>
                        </button>
                      </mat-menu>
                    </div>
                    </div>
                    </div>
                    <div class="box">
                        <h2>{{project.ProjectTitle}}<br><span>{{project.GMOUCategory}}</span></h2>
                        <p [innerHTML]="project.Description | truncateText:140"> </p>
                        <span>
                            <ul>
                             <span style="font-weight: bold; margin-top: 5px;">Project Timeline</span>

                              <div style="display: flex; flex-direction: row; align-items: center; width: 200px;">
                                <mat-progress-bar mode="determinate"  [value]="days_between(project.StartDate, project.EndDate)" style="margin-top: 10px;" *ngIf="days_between(project.StartDate, project.EndDate) > 0"></mat-progress-bar>
                                <mat-progress-bar mode="determinate" color="accent"  [value]="0" *ngIf="(days_between(project.StartDate, project.EndDate) === 0) || (days_between(project.StartDate, project.EndDate) < 0)" style="margin-top: 10px;"></mat-progress-bar>
                                <span style="margin-top: 5px; margin-left: 3px; width: 30%;" *ngIf="(days_between(project.StartDate, project.EndDate) !== 1) && (days_between(project.StartDate, project.EndDate) > 0)">{{days_between(project.StartDate, project.EndDate)}} days</span>
                                <span style="margin-top: 5px; margin-left: 3px; width: 30%;" *ngIf="(days_between(project.StartDate, project.EndDate) === 1) && (days_between(project.StartDate, project.EndDate) > 0)"> {{days_between(project.StartDate, project.EndDate)}} day</span>
                                <span style="margin-top: 5px; margin-left: 3px; width: 30%;" *ngIf="(days_between(project.StartDate, project.EndDate) === 0) || (days_between(project.StartDate, project.EndDate) < 0)"> 0 day</span>

                              </div>

                            </ul>
                        </span>
                    </div>
                </div>
                 </div>
                </div>
              </div>
              </div>

            </div>

        </div>


      </div>
</div>
    </div>
</div>
</div>
</main>
</div>
